import { render, staticRenderFns } from "./LabBuild.vue?vue&type=template&id=12ec9dd7&scoped=true"
import script from "./LabBuild.vue?vue&type=script&lang=ts"
export * from "./LabBuild.vue?vue&type=script&lang=ts"
import style0 from "./labBuild.css?vue&type=style&index=0&id=12ec9dd7&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ec9dd7",
  null
  
)

export default component.exports